/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */

import { NestedOption } from 'devextreme-angular/core';
import {
    Component,
} from '@angular/core';


@Component({
    template: ''
})
export abstract class DxoFilterPanelTexts extends NestedOption {
    get fix(): string {
        return this._getOption('fix');
    }
    set fix(value: string) {
        this._setOption('fix', value);
    }

    get leftPosition(): string {
        return this._getOption('leftPosition');
    }
    set leftPosition(value: string) {
        this._setOption('leftPosition', value);
    }

    get rightPosition(): string {
        return this._getOption('rightPosition');
    }
    set rightPosition(value: string) {
        this._setOption('rightPosition', value);
    }

    get stickyPosition(): string {
        return this._getOption('stickyPosition');
    }
    set stickyPosition(value: string) {
        this._setOption('stickyPosition', value);
    }

    get unfix(): string {
        return this._getOption('unfix');
    }
    set unfix(value: string) {
        this._setOption('unfix', value);
    }

    get addRow(): string {
        return this._getOption('addRow');
    }
    set addRow(value: string) {
        this._setOption('addRow', value);
    }

    get cancelAllChanges(): string {
        return this._getOption('cancelAllChanges');
    }
    set cancelAllChanges(value: string) {
        this._setOption('cancelAllChanges', value);
    }

    get cancelRowChanges(): string {
        return this._getOption('cancelRowChanges');
    }
    set cancelRowChanges(value: string) {
        this._setOption('cancelRowChanges', value);
    }

    get confirmDeleteMessage(): string {
        return this._getOption('confirmDeleteMessage');
    }
    set confirmDeleteMessage(value: string) {
        this._setOption('confirmDeleteMessage', value);
    }

    get confirmDeleteTitle(): string {
        return this._getOption('confirmDeleteTitle');
    }
    set confirmDeleteTitle(value: string) {
        this._setOption('confirmDeleteTitle', value);
    }

    get deleteRow(): string {
        return this._getOption('deleteRow');
    }
    set deleteRow(value: string) {
        this._setOption('deleteRow', value);
    }

    get editRow(): string {
        return this._getOption('editRow');
    }
    set editRow(value: string) {
        this._setOption('editRow', value);
    }

    get saveAllChanges(): string {
        return this._getOption('saveAllChanges');
    }
    set saveAllChanges(value: string) {
        this._setOption('saveAllChanges', value);
    }

    get saveRowChanges(): string {
        return this._getOption('saveRowChanges');
    }
    set saveRowChanges(value: string) {
        this._setOption('saveRowChanges', value);
    }

    get undeleteRow(): string {
        return this._getOption('undeleteRow');
    }
    set undeleteRow(value: string) {
        this._setOption('undeleteRow', value);
    }

    get validationCancelChanges(): string {
        return this._getOption('validationCancelChanges');
    }
    set validationCancelChanges(value: string) {
        this._setOption('validationCancelChanges', value);
    }

    get exportAll(): string {
        return this._getOption('exportAll');
    }
    set exportAll(value: string) {
        this._setOption('exportAll', value);
    }

    get exportSelectedRows(): string {
        return this._getOption('exportSelectedRows');
    }
    set exportSelectedRows(value: string) {
        this._setOption('exportSelectedRows', value);
    }

    get exportTo(): string {
        return this._getOption('exportTo');
    }
    set exportTo(value: string) {
        this._setOption('exportTo', value);
    }

    get clearFilter(): string {
        return this._getOption('clearFilter');
    }
    set clearFilter(value: string) {
        this._setOption('clearFilter', value);
    }

    get createFilter(): string {
        return this._getOption('createFilter');
    }
    set createFilter(value: string) {
        this._setOption('createFilter', value);
    }

    get filterEnabledHint(): string {
        return this._getOption('filterEnabledHint');
    }
    set filterEnabledHint(value: string) {
        this._setOption('filterEnabledHint', value);
    }

    get groupByThisColumn(): string {
        return this._getOption('groupByThisColumn');
    }
    set groupByThisColumn(value: string) {
        this._setOption('groupByThisColumn', value);
    }

    get groupContinuedMessage(): string {
        return this._getOption('groupContinuedMessage');
    }
    set groupContinuedMessage(value: string) {
        this._setOption('groupContinuedMessage', value);
    }

    get groupContinuesMessage(): string {
        return this._getOption('groupContinuesMessage');
    }
    set groupContinuesMessage(value: string) {
        this._setOption('groupContinuesMessage', value);
    }

    get ungroup(): string {
        return this._getOption('ungroup');
    }
    set ungroup(value: string) {
        this._setOption('ungroup', value);
    }

    get ungroupAll(): string {
        return this._getOption('ungroupAll');
    }
    set ungroupAll(value: string) {
        this._setOption('ungroupAll', value);
    }

    get cancel(): string {
        return this._getOption('cancel');
    }
    set cancel(value: string) {
        this._setOption('cancel', value);
    }

    get emptyValue(): string {
        return this._getOption('emptyValue');
    }
    set emptyValue(value: string) {
        this._setOption('emptyValue', value);
    }

    get ok(): string {
        return this._getOption('ok');
    }
    set ok(value: string) {
        this._setOption('ok', value);
    }

    get avg(): string {
        return this._getOption('avg');
    }
    set avg(value: string) {
        this._setOption('avg', value);
    }

    get avgOtherColumn(): string {
        return this._getOption('avgOtherColumn');
    }
    set avgOtherColumn(value: string) {
        this._setOption('avgOtherColumn', value);
    }

    get count(): string {
        return this._getOption('count');
    }
    set count(value: string) {
        this._setOption('count', value);
    }

    get max(): string {
        return this._getOption('max');
    }
    set max(value: string) {
        this._setOption('max', value);
    }

    get maxOtherColumn(): string {
        return this._getOption('maxOtherColumn');
    }
    set maxOtherColumn(value: string) {
        this._setOption('maxOtherColumn', value);
    }

    get min(): string {
        return this._getOption('min');
    }
    set min(value: string) {
        this._setOption('min', value);
    }

    get minOtherColumn(): string {
        return this._getOption('minOtherColumn');
    }
    set minOtherColumn(value: string) {
        this._setOption('minOtherColumn', value);
    }

    get sum(): string {
        return this._getOption('sum');
    }
    set sum(value: string) {
        this._setOption('sum', value);
    }

    get sumOtherColumn(): string {
        return this._getOption('sumOtherColumn');
    }
    set sumOtherColumn(value: string) {
        this._setOption('sumOtherColumn', value);
    }

    get allFields(): string {
        return this._getOption('allFields');
    }
    set allFields(value: string) {
        this._setOption('allFields', value);
    }

    get columnFields(): string {
        return this._getOption('columnFields');
    }
    set columnFields(value: string) {
        this._setOption('columnFields', value);
    }

    get dataFields(): string {
        return this._getOption('dataFields');
    }
    set dataFields(value: string) {
        this._setOption('dataFields', value);
    }

    get filterFields(): string {
        return this._getOption('filterFields');
    }
    set filterFields(value: string) {
        this._setOption('filterFields', value);
    }

    get rowFields(): string {
        return this._getOption('rowFields');
    }
    set rowFields(value: string) {
        this._setOption('rowFields', value);
    }

    get columnFieldArea(): string {
        return this._getOption('columnFieldArea');
    }
    set columnFieldArea(value: string) {
        this._setOption('columnFieldArea', value);
    }

    get dataFieldArea(): string {
        return this._getOption('dataFieldArea');
    }
    set dataFieldArea(value: string) {
        this._setOption('dataFieldArea', value);
    }

    get filterFieldArea(): string {
        return this._getOption('filterFieldArea');
    }
    set filterFieldArea(value: string) {
        this._setOption('filterFieldArea', value);
    }

    get rowFieldArea(): string {
        return this._getOption('rowFieldArea');
    }
    set rowFieldArea(value: string) {
        this._setOption('rowFieldArea', value);
    }

    get collapseAll(): string {
        return this._getOption('collapseAll');
    }
    set collapseAll(value: string) {
        this._setOption('collapseAll', value);
    }

    get dataNotAvailable(): string {
        return this._getOption('dataNotAvailable');
    }
    set dataNotAvailable(value: string) {
        this._setOption('dataNotAvailable', value);
    }

    get expandAll(): string {
        return this._getOption('expandAll');
    }
    set expandAll(value: string) {
        this._setOption('expandAll', value);
    }

    get exportToExcel(): string {
        return this._getOption('exportToExcel');
    }
    set exportToExcel(value: string) {
        this._setOption('exportToExcel', value);
    }

    get grandTotal(): string {
        return this._getOption('grandTotal');
    }
    set grandTotal(value: string) {
        this._setOption('grandTotal', value);
    }

    get noData(): string {
        return this._getOption('noData');
    }
    set noData(value: string) {
        this._setOption('noData', value);
    }

    get removeAllSorting(): string {
        return this._getOption('removeAllSorting');
    }
    set removeAllSorting(value: string) {
        this._setOption('removeAllSorting', value);
    }

    get showFieldChooser(): string {
        return this._getOption('showFieldChooser');
    }
    set showFieldChooser(value: string) {
        this._setOption('showFieldChooser', value);
    }

    get sortColumnBySummary(): string {
        return this._getOption('sortColumnBySummary');
    }
    set sortColumnBySummary(value: string) {
        this._setOption('sortColumnBySummary', value);
    }

    get sortRowBySummary(): string {
        return this._getOption('sortRowBySummary');
    }
    set sortRowBySummary(value: string) {
        this._setOption('sortRowBySummary', value);
    }

    get total(): string {
        return this._getOption('total');
    }
    set total(value: string) {
        this._setOption('total', value);
    }

    get addRowToNode(): string {
        return this._getOption('addRowToNode');
    }
    set addRowToNode(value: string) {
        this._setOption('addRowToNode', value);
    }
}
